import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

import {currentResource} from '../../../util/utils';

import columns from './columns';

import CustomTable from '../../CoreWrappers/CustomTable';

const RelateAccountsTable = ({items = null, onSelect = null, errorMessage = null}) => {
	if (!items) return false;
	const labels = currentResource.relateAccountsTableLabels;

	const handleChange = (accountId) => onSelect(accountId);

	const props = {
		id: 'relateAccountsTable',
		data: items,
		defaultColumnSort: 'accountName',
		columns: columns(labels, handleChange),
		labels: {
			emptyMessage: labels.noDataFound,
			show: labels.show
		}
	};
	if (errorMessage) props.errorMessage = errorMessage;
	return <CustomTable {...props} />;
};

RelateAccountsTable.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
			componentAccount: PropTypes.string.isRequired,
			pspIndexes: PropTypes.any.isRequired
		})
	)
};

export default RelateAccountsTable;
